<template>
  <div class="request-contact-info-main-section mt-4">
    <section-title
      content="Información adicional a ser considerada"
      :has-line="true"
    />
    <div class="p-4">
      <span v-if="isReadOnly" class="data-content d-block">
        {{ model | empty }}
      </span>
      <custom-text-area
        v-else
        v-model="model"
        :count-classes="['float-right']"
        :maxlength="3000"
        show-char-count
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomTextArea from 'CustomTextArea';
export default {
  name: 'RequestAdditionalInfo',
  components: {
    SectionTitle,
    CustomTextArea,
  },
  props: {
    value: {
      type: String,
      default: () => '',
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
